<template>
    <div class="main">
        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <!-- Instituição -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                                <el-select v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-else>
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                            </div>
                        </el-col>
                    </el-row>

                    <!-- Intervalo de datas -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data inicial (opcional)">
                                <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Início" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data final (opcional)">
                                <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Fim" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" class="u-text-right">
                        <el-button @click="gerar()" type="primary">
                            <i class="el-icon-printer"></i> GERAR PDF
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        filtro: {
            instituicao_id: '',
            data_inicio: '',
            data_fim: ''
        }
    }),
    computed: {
        ehSmed () {
            const t = this.$store.state.user.tipo
            return t == 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
    },
    methods: {
        gerar () {
            if (this.ehSmed && !this.filtro.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a instituição.', type: 'warning' })
                return
            }

            window.eventBus.$emit('print', {
                url: '/api/merenda/cardapio/imprimir',
                param: {
                    instituicao_id: this.filtro.instituicao_id || '',
                    data_inicio: this.filtro.data_inicio || '',
                    data_fim: this.filtro.data_fim || ''
                }
            })
        }
    }
}
</script>
